import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import MethodologyAnchor from '../shared/methodologyAnchor/MethodologyAnchor';
import { LOCATIONDATA } from './Benefits.constants';
import {
  StyledCaption,
  StyledItem,
  StyledItems,
  StyledSection,
  StyledText,
  StyledValue
} from './LocationPreference.styled';

const LocationPreference: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');

  const locationData = LOCATIONDATA(t).sort((a, b) =>
    a.value > b.value ? -1 : 1
  );

  return (
    <>
      <StyledItems>
        {locationData.map((item) => (
          <StyledItem key={item.type}>
            <StyledValue className={item.type}>
              {item.value.toFixed(1)}%
            </StyledValue>
            <StyledCaption>{item.label}</StyledCaption>
          </StyledItem>
        ))}
      </StyledItems>
      <MethodologyAnchor />
      <StyledSection>
        <img
          src={getPublicPath('/images/stateSector/2023/location.gif')}
          alt=""
        />
        <StyledText>
          <HtmlTrans
            ns="developer-career-report-2023"
            i18nKey="mandecar23.benefits.location.text"
          />
        </StyledText>
      </StyledSection>
    </>
  );
};

export default LocationPreference;
